import React, { useState } from "react";
import "./FAQSection.css";

import {
  ChevronDown,
  ChevronUp,
} from "lucide-react";

const faqData = [

  {
    question:
      "How much does custom software development cost?",

    answer:
      "The cost depends on the type of software, number of features, UI complexity, backend architecture, integrations, security requirements and deployment needs. A simple MVP costs less, while enterprise platforms, ecommerce systems, CRM software, AI tools and dashboards require detailed planning and phased development. After understanding your requirement, we provide a clear feature-wise estimate with timeline, technology stack and delivery milestones.",
  },

  {
    question:
      "How long does software development take?",

    answer:
      "Timeline depends on project size and complexity. A small business website or MVP may take a few weeks, while a full software platform with authentication, dashboard, payment gateway, API integration, admin panel, reporting and cloud deployment may require multiple phases. We follow a structured process: requirement analysis, UI/UX design, frontend development, backend development, testing, deployment and post-launch improvements.",
  },

  {
    question:
      "Do you build AI-powered software systems?",

    answer:
      "Yes. We develop AI-powered systems such as OCR platforms, document automation tools, AI chatbots, intelligent dashboards, recommendation engines, predictive analytics systems, business workflow automation and generative AI applications. Based on the project, we can integrate AI models, NLP, computer vision, vector databases, RAG-based knowledge search and cloud AI APIs.",
  },

  {
    question:
      "Which technologies do you use for development?",

    answer:
      "We use modern, scalable and production-ready technologies. For frontend, we work with React.js, Next.js, Tailwind CSS and component-based UI systems. For backend, we use FastAPI, Node.js, Express.js and REST APIs. For databases, we use PostgreSQL, MongoDB, Redis and cloud storage. For deployment, we use Docker, Nginx, VPS, AWS, CI/CD pipelines and scalable cloud infrastructure.",
  },

  {
    question:
      "Do you provide deployment and cloud support?",

    answer:
      "Yes. We provide complete production deployment support including VPS setup, domain configuration, SSL certificate installation, Nginx reverse proxy, Docker deployment, backend hosting, frontend deployment, database setup, environment configuration and server monitoring. We also help businesses plan scalable cloud architecture using AWS, DigitalOcean, Firebase, PostgreSQL, Redis and containerized workflows.",
  },

  {
    question:
      "Do you build scalable ecommerce platforms?",

    answer:
      "Yes. We build modern ecommerce platforms with product catalog management, cart system, checkout flow, payment gateway integration, customer dashboard, admin panel, order management, inventory control, coupons, delivery tracking and analytics. We can also build advanced ecommerce ecosystems with franchise management, multi-vendor support, mobile-first UI, AI recommendations and backend APIs for mobile apps.",
  },

  {
    question:
      "Can you build custom admin dashboards for our business?",

    answer:
      "Yes. We build custom admin dashboards for managing operations, users, customers, orders, products, leads, reports, approvals and analytics from one centralized system. Dashboards can include role-based access control, realtime charts, filters, export to PDF or Excel, activity logs, notifications, status tracking and plug-and-play modules for future expansion.",
  },

  {
    question:
      "Do you create mobile applications?",

    answer:
      "Yes. We develop mobile applications for Android, iOS and cross-platform use cases. Depending on the requirement, we can build apps using React Native, Flutter or modern web-to-mobile architecture. We also connect mobile apps with backend APIs, admin dashboards, payment gateways, push notifications, GPS tracking, OTP login and cloud databases.",
  },

  {
    question:
      "Can you modernize an existing website or software?",

    answer:
      "Yes. We can redesign and modernize existing websites, dashboards, mobile apps and backend systems. This may include improving UI/UX, making the design responsive, optimizing performance, restructuring old code, improving database design, adding APIs, enhancing security, migrating to cloud and converting outdated systems into scalable modern platforms.",
  },

  {
    question:
      "Do you provide support after project delivery?",

    answer:
      "Yes. We provide post-launch support based on the project requirement. Support may include bug fixing, server monitoring, security updates, performance optimization, database maintenance, backup management, feature enhancements and version upgrades. For business-critical platforms such as ecommerce systems, dashboards and cloud applications, we recommend regular maintenance support.",
  },

];

const FAQSection = () => {

  const [activeIndex, setActiveIndex] =
    useState(null);

  const toggleFAQ = (index) => {

    setActiveIndex(
      activeIndex === index ? null : index
    );

  };

  return (

    <section className="faq-section">

      <div className="faq-container">

        {/* HEADER */}

        <div className="faq-header">

          <p className="faq-label">
            FREQUENTLY ASKED QUESTIONS
          </p>

          <h2 className="faq-title">
            Common Questions
            <br />
            About Our Services
          </h2>

          <p className="faq-description">

            Learn more about our software development
            process, pricing approach, technologies,
            AI systems, cloud deployment and scalable
            enterprise solutions.

          </p>

        </div>

        {/* FAQ LIST */}

        <div className="faq-list">

          {faqData.map((faq, index) => {

            const isActive =
              activeIndex === index;

            return (

              <div
                className={`faq-item ${
                  isActive ? "faq-active" : ""
                }`}
                key={index}
              >

                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={isActive}
                  type="button"
                >

                  <span>
                    {faq.question}
                  </span>

                  <div className="faq-icon">

                    {isActive ? (
                      <ChevronUp size={20} />
                    ) : (
                      <ChevronDown size={20} />
                    )}

                  </div>

                </button>

                <div
                  className={`faq-answer-wrapper ${
                    isActive ? "faq-open" : ""
                  }`}
                >

                  <div className="faq-answer">

                    <p>
                      {faq.answer}
                    </p>

                  </div>

                </div>

              </div>

            );

          })}

        </div>

      </div>

    </section>

  );

};

export default FAQSection;